enum Step {
  INITIAL = 'INITIAL',
  AWAITING_PUSH = 'AWAITING_PUSH',
  PHONE_NUMBER = 'PHONE_NUMBER',
  RECOVERY_METHOD = 'RECOVERY_METHOD',
  RECOVERY_PHONE_NUMBER = 'RECOVERY_PHONE_NUMBER',
  RECOVERY_CODE = 'RECOVERY_CODE',
  SUCCESS = 'SUCCESS',
}

enum Flow {
  PUSH_AND_SMS = 'PUSH_AND_SMS',
  PUSH_AND_CODE = 'PUSH_AND_CODE',
  SMS_AND_CODE = 'SMS_AND_CODE',
}

const flows = {
  [Flow.PUSH_AND_SMS]: [
    Step.INITIAL,
    Step.AWAITING_PUSH,
    Step.RECOVERY_METHOD,
    Step.RECOVERY_PHONE_NUMBER,
    Step.SUCCESS,
  ],
  [Flow.PUSH_AND_CODE]: [Step.INITIAL, Step.AWAITING_PUSH, Step.RECOVERY_METHOD, Step.RECOVERY_CODE, Step.SUCCESS],
  [Flow.SMS_AND_CODE]: [Step.INITIAL, Step.PHONE_NUMBER, Step.RECOVERY_CODE, Step.SUCCESS],
}

const stepModule = {
  [Step.INITIAL]: 'two-factor-auth-setup',
  [Step.AWAITING_PUSH]: 'two-factor-auth-setup.awaiting-push',
  [Step.PHONE_NUMBER]: 'two-factor-auth-setup.phone-number',
  [Step.RECOVERY_METHOD]: 'two-factor-auth-setup.recovery-method',
  [Step.RECOVERY_PHONE_NUMBER]: 'two-factor-auth-setup.recovery-phone-number',
  [Step.RECOVERY_CODE]: 'two-factor-auth-setup.recovery-code',
  [Step.SUCCESS]: 'two-factor-auth-setup.success',
}

export { Step, Flow, flows, stepModule }
